export const UserSettingsKeys = {
    EnhancedContentExpand: "EnhancedContentExpand",
    EnhancedContentShow: "EnhancedContentShow",
    PreferredLanguage: "PreferredLanguage",
    TiasDeletedShow: "TiasDeletedShow",
    NarrowView: "NarrowView",
    SearchResultsSortBy: "SearchResultsSortBy",
    MyLiNKDefaultTab: "MyLiNKDefaultTab",
    MyLiNKBookmarksDefaultPill: "MyLiNKBookmarksDefaultPill",
    MyLiNKBookmarksDefaultPublicationsSort:
        "MyLiNKBookmarksDefaultPublicationsSort",
    MyLiNKBookmarksDefaultCollectionsSort:
        "MyLiNKBookmarksDefaultCollectionsSort",
    MyLiNKBookmarksDefaultColorSort: "MyLiNKBookmarksDefaultColorSort",
    MyLiNKBookmarksDefaultAllSort: "MyLiNKBookmarksDefaultAllSort",
    SelectedUserDashboardPublicationTab: "SelectedUserDashboardPublicationTab",
    SelectedUserDashboardPublicationView:
        "SelectedUserDashboardPublicationView",
    SearchProviderName: "SearchProviderName",
    EnableAIChat: "EnableAIChat",
    EnableNotebook: "EnableNotebook",
    AIChatBetaAccess: "AIChatBetaAccess",
    AIChatUseUserFavorites: "AIChatUseUserFavorites",
    NotebookEnhancedContentShow: "NotebookEnhancedContentShow",
} as const;
